import React, { useState } from "react";

const SidebarRelatedPosts = ({ posts = [], featuredPosts = [] }) => {
  const [activeTab, setActiveTab] = useState("related");

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return "No date";

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const getImage = (post) =>
    post?.featuredImage
      ? `${process.env.REACT_APP_DO_SPACES_URL}${post.featuredImage}`
      : "/placeholder.jpg";

  const renderPosts = (items) => {
    if (!items.length) {
      return (
        <p className="rounded-md bg-slate-50 p-3 text-sm text-gray-500">
          No posts available yet.
        </p>
      );
    }

    return items.map((post, index) => (
      <article key={index} className="group flex gap-3 rounded-md bg-white p-3 shadow-sm ring-1 ring-slate-100 transition hover:ring-[rgba(126,34,206,0.16)]">
        <a href={post.link} className="block shrink-0 overflow-hidden rounded-md bg-slate-100">
          <img
            className="h-20 w-24 object-cover transition duration-500 group-hover:scale-105"
            src={getImage(post)}
            alt={post.title}
            title={post.title}
          />
        </a>
        <div className="min-w-0">
          <a
            href={post.link}
            className="line-clamp-2 text-sm font-bold leading-5 text-gray-900 hover:text-[rgb(126,34,206)]"
          >
            {post.title}
          </a>
          <p className="mt-1 text-xs font-medium text-gray-500">
            {formatDate(post.date)} / {post.readMins || "N/A"} min
          </p>
        </div>
      </article>
    ));
  };

  return (
    <div className="rounded-md border border-slate-200 bg-slate-50 p-4 shadow-sm">
      <div className="mb-4 flex rounded-sm bg-white p-1 shadow-sm">
        <button
          type="button"
          className={`flex-1 rounded-sm px-3 py-2 text-sm font-semibold transition ${
            activeTab === "related"
              ? "bg-[rgba(126,34,206,0.08)] text-[rgb(126,34,206)]"
              : "text-gray-500 hover:text-gray-900"
          }`}
          onClick={() => setActiveTab("related")}
        >
          Related
        </button>
        <button
          type="button"
          className={`flex-1 rounded-sm px-3 py-2 text-sm font-semibold transition ${
            activeTab === "featured"
              ? "bg-[rgba(126,34,206,0.08)] text-[rgb(126,34,206)]"
              : "text-gray-500 hover:text-gray-900"
          }`}
          onClick={() => setActiveTab("featured")}
        >
          Featured
        </button>
      </div>

      <div className="space-y-3">
        {activeTab === "related" ? renderPosts(posts) : renderPosts(featuredPosts)}
      </div>
    </div>
  );
};

export default SidebarRelatedPosts;
